export const translations = {
  en: {
    nav: {
      offers: "Offers",
      howItWorks: "How it works",
      gallery: "Gallery",
      testimonials: "Reviews",
      faq: "FAQ",
      contact: "Contact",
      bookNow: "Check availability"
    },
    hero: {
      headline: "Premium Boat & Jet Ski Rentals in Fuengirola",
      subheadline: "Experience the ultimate Costa del Sol adventure. Fully insured, certified guides, and unforgettable memories await.",
      ctaPrimary: "Check availability",
      ctaSecondary: "View offers",
      badge: "#1 Rated in Costa del Sol"
    },
    filters: {
      all: "All",
      jetskis: "Jet Skis",
      boats: "Boats",
      sunset: "Sunset",
      family: "Family",
      private: "Private"
    },
    offerCard: {
      duration: "Duration",
      capacity: "Capacity",
      bookBtn: "Book now",
      detailsBtn: "Details",
      checkAvailability: "Check Availability",
      perGroup: "per group",
      perPerson: "per person",
      guidedTour: "Guided tour",
      selfGuided: "Self-guided",
      minutes: "minutes",
      hour: "hour",
      hours: "hours",
      upTo: "Up to",
      people: "people",
      boatRental: "Boat Rental",
      jetSki: "Jet Ski",
      badgeBestseller: "BESTSELLER",
      badgeNew: "NEW",
      badgePopular: "POPULAR",
      loading: "Loading offers...",
      showAll: "Show All Offers",
      bundleBadge: "Multiple durations",
      fromPrice: "From",
      fromDuration: "From",
      selectDuration: "Choose duration"
    },
    socialProof: {
      fullyInsured: "Fully Insured",
      fullyInsuredDesc: "100% Safe & Secure",
      premiumFleet: "Premium Fleet",
      premiumFleetDesc: "Top Quality Boats",
      expertCrew: "Expert Crew",
      expertCrewDesc: "Certified Guides",
      topRated: "Top Rated",
      topRatedDesc: "5-Star Reviews"
    },
    howItWorks: {
      title: "Your Journey Starts Here",
      subtitle: "Simple, secure, and seamless booking process.",
      step1Title: "1. Choose Your Adventure",
      step1Desc: "Browse our fleet of premium boats and jet skis. Select the perfect experience for your group.",
      step2Title: "2. Book Instantly",
      step2Desc: "Check availability and book securely online. You'll receive instant confirmation and meeting details.",
      step3Title: "3. Enjoy the Ride",
      step3Desc: "Meet us at the marina. Our crew will handle everything while you make unforgettable memories."
    },
    sections: {
      offersTitle: "Our Premium Fleet",
      offersSubtitle: "Choose from our selection of high-end boats and jet skis",
      howItWorksTitle: "How It Works",
      safetyTitle: "Safety & Trust",
      galleryTitle: "Gallery",
      gallerySubtitle: "Moments captured on the Costa del Sol",
      galleryView: "View",
      testimonialsTitle: "What Our Clients Say",
      faqTitle: "Frequently Asked Questions",
      locationTitle: "Find Us in Fuengirola",
      finalCtaTitle: "Ready for your adventure?",
      finalCtaSubtitle: "Book your experience today and create memories that last a lifetime.",
      finalCtaBtn: "Book Now"
    },
    welcome: {
      title: "Welcome to Fuengirola Port,",
      titleHighlight: "Your Adventure Starts Here.",
      description: "We warmly welcome you to our base at Fuengirola Marina. Our passionate team is dedicated to making your nautical experience unforgettable, with personalized service and local expertise.",
      feature1: "Prime Marina Location",
      feature2: "Expert Local Team",
      feature3: "Personalized Service",
      feature4: "Memorable Experiences",
      testimonial: "The team's warm welcome made all the difference. Truly exceptional!",
      testimonialAuthor: "- Maria González, Spain"
    },
    faq: {
      q1: "Do I need a license to rent a boat?",
      l1: "No license is required for boats up to 15 hp; we provide full briefing on site.",
      a1: "For boats up to 15hp, no license is required! We provide full instruction. For larger boats, a valid license is needed, or you can hire one of our professional skippers.",
      q2: "Is fuel included in the price?",
      l2: "Fuel is included on most 1–4 hour rentals; full-day trips may bill fuel on return.",
      a2: "For most rentals (1-4 hours), fuel is included. For full-day rentals or high-consumption boats, fuel is charged based on usage upon return.",
      q3: "What is the cancellation policy?",
      l3: "Free cancellation up to 24 hours before departure; bad weather means full refund or reschedule.",
      a3: "We offer free cancellation up to 24 hours before your booking. Bad weather cancellations are fully refunded or rescheduled.",
      q4: "Is there a minimum age for jet skis?",
      l4: "Drivers must be 18+ (16 with parental consent); passengers from about 6 years old.",
      a4: "Drivers must be 18+ (or 16 with parental consent). Passengers can be younger, generally 6+ years old depending on conditions.",
      q5: "Where is the meeting point?",
      l5: "Puerto Deportivo de Fuengirola — exact berth details are sent in your booking confirmation.",
      a5: "We are located at the Puerto Deportivo de Fuengirola. You'll receive the exact dock number and Google Maps location in your booking confirmation.",
      q6: "Can I rent a jet ski without a boating license?",
      l6: "Yes — jet ski sessions include a certified instructor; no license required.",
      a6: "Jet ski rentals at Wownautic include professional supervision. No boating license is required; drivers must meet the minimum age and follow safety briefing.",
      q7: "When is the dolphin-watching boat tour available?",
      l7: "Dolphin excursions run in season from Fuengirola Marina; duration and price vary by offer — see live catalog.",
      a7: "Our dolphin-watching trips depart from Fuengirola Marina on the Costa del Sol. Seasonality depends on sea conditions and wildlife; check each tour page for current duration, schedule, and TTC price.",
      q8: "What happens if the weather is bad on my booking day?",
      l8: "Unsafe weather triggers a free reschedule or full refund — we contact you if conditions require a change.",
      a8: "If the captain cancels for safety (high wind, storms), you receive a full refund or free rebooking. Light rain may not cancel short rentals; we confirm by phone or WhatsApp."
    },
    geo: {
      homeSummary: "Wownautic offers boat and jet ski rentals at Fuengirola Marina (Costa del Sol, Málaga). Online booking, professional crew, no license required for jet skis. From {{minPrice}}€ TTC.",
      homeSummaryFallback: "Wownautic offers boat and jet ski rentals at Fuengirola Marina (Costa del Sol, Málaga). Online booking, professional crew, no license required for jet skis.",
      offerSummary: "{{title}}: {{duration}}, {{price}}€ TTC, up to {{capacity}} people, departing Fuengirola Marina, Costa del Sol."
    },
    offer: {
      inclusions: {
        captain: "Professional captain",
        safety: "Safety equipment",
        drinks: "Drinks included",
        insurance: "Full insurance"
      },
      goodToKnow: {
        meeting: "Meeting point:",
        meetingValue: "Puerto Deportivo de Fuengirola",
        language: "Language:",
        languageValue: "English, Español, Français",
        cancellation: "Cancellation:",
        cancellationValue: "Free up to 24h before"
      },
      aboutTitle: "About the experience",
      includedTitle: "What's included",
      goodToKnowTitle: "Good to know",
      imageAlt: "{{title}} at Fuengirola Marina — photo {{index}}"
    },
    gallery: {
      altJetSki: "Jet ski rental at Fuengirola Marina, Costa del Sol",
      altBoatTour: "Guided boat tour from Fuengirola port",
      altDolphins: "Dolphin watching excursion Costa del Sol",
      altSpeedboat: "Speedboat rental Fuengirola Marina",
      altPartyBoat: "Party boat charter Fuengirola",
      altMarina: "Wownautic boats at Fuengirola Marina",
      altSunset: "Sunset boat cruise Costa del Sol",
      altFishing: "Fishing trip boat Fuengirola",
      altGroup: "Group boat experience Wownautic Fuengirola",
      altCoast: "Coastal boat ride Fuengirola Málaga",
      altTrolling: "Trolling fishing charter Costa del Sol",
      altFamily: "Family boat rental Fuengirola Marina"
    },
    location: {
      description: "Visit us at the heart of Fuengirola Marina. Easy parking and accessible facilities.",
      address: "Address",
      addressLine1: "Puerto Deportivo de Fuengirola, Local 45",
      addressLine2: "29640 Fuengirola, Málaga",
      phone: "Phone / WhatsApp",
      email: "Email",
      hours: "Opening Hours",
      hoursValue: "Mon - Sun: 10:00 - 20:00",
      mapButton: "Open in Google Maps"
    },
    contact: {
      title: "Contact info",
      formTitle: "Leave a message",
      phoneLabel: "Phone number",
      emailLabel: "Email address",
      addressLabel: "Office address",
      firstName: "First Name",
      lastName: "Last Name",
      emailPlaceholder: "Email Address",
      subject: "Subject",
      message: "Your Message",
      send: "Send",
      sending: "Sending...",
      successMessage: "Message sent successfully! We'll get back to you soon.",
      errorMessage: "Failed to send message. Please try again or contact us directly."
    },
    footer: {
      copyright: " 2026 Wow Nautic. All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      description: "Premium boat rental services in Costa del Sol. Creating unforgettable memories since 2024.",
      quickLinks: "Quick Links",
      offers: "Offers",
      gallery: "Gallery",
      contact: "Contact",
      faq: "FAQ",
      legal: "Legal",
      cookiePolicy: "Cookie Policy",
      newsletter: "Stay Updated",
      emailPlaceholder: "Enter your email",
      subscribe: "Subscribe",
      subscribing: "Subscribing...",
      newsletterCheckEmail: "Check your inbox to confirm your subscription!",
      newsletterConfirmed: "Your email has been confirmed! Welcome aboard!",
      newsletterAlreadyVerified: "You are already subscribed!",
      newsletterInvalid: "Invalid verification link.",
      newsletterInvalidEmail: "Please enter a valid email address.",
      newsletterError: "An error occurred. Please try again."
    },
    search: {
      resourceType: "I'm booking a",
      boat: "Boat",
      jetski: "Jet Ski",
      persons: "Number of persons",
      person: "person",
      people: "people",
      searchBtn: "Search",
      resultsTitle: "Available offers",
      noResults: "No offers match your search. Try different criteria."
    },
    stickyMobile: {
      viewOffers: "View Offers",
      checkAvailability: "Check Availability"
    },
    whatsApp: {
      chatWithUs: "Chat with us!"
    },
    chatWidget: {
      chatWithUs: "Chat with us!",
      online: "Online",
      placeholder: "Type your message...",
      welcomeMessage: "Hello! 👋 How can I help you today? Feel free to ask about our boats, jet skis, or any of our services.",
      errorMessage: "Sorry, an error occurred. Please try again.",
      ariaLabel: "Open chat",
      newConversation: "New chat",
      newConversationTitle: "Start a new conversation (clears context)",
      dictationStart: "Dictate message",
      dictationStop: "Stop dictation",
      dictationNotSupported: "Voice input is not available in this browser (try Chrome or Edge)."
    },
    booking: {
      title: "Check Availability",
      subtitle: "Fill out the form below and we'll get back to you within 30 minutes.",
      selectParticipants: "Select Number of Participants",
      selectDate: "Select Date",
      continueToTime: "Continue to Time Selection",
      selectedDate: "Selected Date",
      change: "Change",
      availableSlots: "Available Time Slots",
      noSlots: "No available slots for this date. Please select another date.",
      spotsLeft: "spot left",
      spotsLeftPlural: "spots left",
      back: "Back",
      continueToDetails: "Continue to Details",
      summary: "Summary",
      edit: "Edit",
      date: "Date",
      time: "Time",
      participants: "Participants",
      total: "Total",
      firstName: "First Name",
      lastName: "Last Name",
      email: "Email",
      phone: "Phone",
      couponCode: "Promo code",
      couponPlaceholder: "Enter your promo code",
      couponValidating: "Validating coupon...",
      couponApplied: "Promo code applied",
      couponInvalid: "Invalid promo code",
      couponReasonExpired: "This promo code has expired.",
      couponReasonOfferNotAllowed: "This promo code is not valid for this offer.",
      couponReasonQuotaExhausted: "This promo code is no longer available.",
      couponReasonCustomerEmailRequired: "Enter your email to validate this promo code.",
      couponReasonMinOrder: "Minimum amount not reached for this promo code.",
      couponReasonNotStarted: "This promo code is not active yet.",
      couponReasonBookingPeriod: "This promo code is not valid for the selected booking date.",
      discount: "Discount",
      continueToPayment: "Continue to Payment",
      processing: "Processing...",
      bookingSummary: "Booking Summary",
      name: "Name",
      backToDetails: "Back to details",
      expiryWarning: "Your booking will expire in 15 minutes if payment is not completed.",
      paymentOverlayTitle: "Processing your payment",
      paymentOverlayMessage: "Please wait while we securely process your payment. Do not close this page.",
      paymentOverlayConfirmTitle: "Confirming your booking",
      paymentOverlayConfirmMessage: "Payment received! We are finalizing your reservation with WowBooking."
    },
    bookingConfirmation: {
      title: "Booking confirmed",
      subtitle: "Thank you for choosing Wownautic. Your adventure is booked!",
      processing: "Confirming your payment...",
      success: "Your booking is confirmed. You will receive a confirmation email shortly.",
      errorTitle: "Payment issue",
      paymentFailed: "Payment was not completed. Please try again.",
      paymentIncomplete: "Payment is still being processed. Please contact us if you were charged.",
      confirmError: "Payment received but booking confirmation failed. Please contact support.",
      missingBooking: "Invalid confirmation link. Please contact support.",
      backHome: "Back to home",
      contactUs: "Contact us",
      referenceLabel: "Booking reference",
      detailsTitle: "Your reservation",
      experience: "Experience",
      date: "Date",
      time: "Time",
      participants: "Participants",
      equipment: "Equipment",
      guest: "Guest name",
      email: "Email",
      phone: "Phone",
      subtotal: "Subtotal",
      discount: "Discount",
      totalPaid: "Total paid",
      meetingTitle: "Meeting point",
      meetingPoint: "Puerto Deportivo de Fuengirola, Costa del Sol",
      meetingHint: "Exact berth and Google Maps link are included in your confirmation email.",
      emailNotice: "A confirmation email with all details has been sent to {{email}}."
    },
    contactConfirmation: {
      title: "Message sent",
      subtitle: "Thank you for contacting Wownautic. We have received your message and will get back to you as soon as possible.",
      emailNotice: "If your request is urgent, you can also reach us by phone at +34 683 17 17 17.",
      backHome: "Back to home",
      sendAnother: "Send another message"
    },
    newsletterConfirmation: {
      titlePending: "Check your inbox",
      subtitlePending: "We sent you a confirmation email. Click the link in the email to complete your subscription.",
      titleConfirmed: "Subscription confirmed",
      subtitleConfirmed: "Your email has been confirmed! Welcome aboard — you'll receive our latest offers and news.",
      titleAlreadyVerified: "Already subscribed",
      subtitleAlreadyVerified: "Your email is already on our newsletter list.",
      titleInvalid: "Invalid link",
      subtitleInvalid: "This verification link is invalid or has expired.",
      titleError: "Something went wrong",
      subtitleError: "An error occurred while confirming your subscription. Please try again.",
      backHome: "Back to home",
      browseOffers: "Browse our offers"
    },
    cookiePolicy: {
      title: "Cookie Policy",
      whatAreCookies: {
        title: "What is a Cookie?",
        description: "A cookie is a small text file that is stored in your browser when you visit almost any website. Its purpose is to enable the website to remember your visit when you browse that page again. Cookies usually store technical information, personal preferences, content customization, usage statistics, links to social networks, access to user accounts, etc. The purpose of the cookie is to adapt the content of the website to your profile and needs. Without cookies, the services offered by any website would be significantly diminished.",
        moreInfo: "If you would like more information about what cookies are, what they store, how to delete them, disable them, etc., please see this document."
      },
      cookiesUsed: {
        title: "Cookies Used on This Website",
        intro: "Following the guidelines of the Spanish Data Protection Agency, we detail the use of cookies made by this website in order to inform you as accurately as possible.",
        ownCookies: {
          title: "This website uses the following own cookies:",
          session: "Session cookies, to ensure that users who write comments on the blog are human and not automated applications. This way spam is combated."
        },
        thirdPartyCookies: {
          title: "This website uses the following third-party cookies:",
          analytics: "Stores cookies to compile statistics on traffic and volume of visits to this website. By using this website you are consenting to the processing of information about you by Google. Therefore, the exercise of any right in this regard must be done by communicating directly with Google.",
          socialMedia: {
            title: "Social Networks",
            description: "Each social network uses its own cookies so that you can click on buttons such as Like or Share."
          }
        }
      },
      disableDelete: {
        title: "Disabling or Deleting Cookies",
        description: "At any time you may exercise your right to disable or delete cookies from this website. These actions are performed differently depending on the browser you are using. Guide to disable cookies in the most popular browsers."
      },
      additionalNotes: {
        title: "Additional Notes",
        note1: "Neither this website nor its legal representatives are responsible for the content or accuracy of the privacy policies that the third parties mentioned in this cookie policy may have.",
        note2: "Web browsers are the tools responsible for storing cookies and from this place you must exercise your right to delete or disable them. Neither this website nor its legal representatives can guarantee the correct or incorrect handling of cookies by the mentioned browsers.",
        note3: "In some cases it is necessary to install cookies so that the browser does not forget your decision not to accept them.",
        note4: "In the case of Google Analytics cookies, this company stores cookies on servers located in the United States and undertakes not to share it with third parties, except in cases where it is necessary for the operation of the system or when the law requires it. According to Google, they do not store your IP address. Google Inc. is a company adhered to the Safe Harbor Agreement that guarantees that all transferred data will be treated with a level of protection in accordance with European regulations. If you want information on the use that Google makes of cookies, we attach this other link."
      },
      contact: "For any questions or queries about this cookie policy, please do not hesitate to contact us through the contact section."
    },
    privacyPolicy: {
      title: "Privacy Policy",
      intro: {
        p1: "This Privacy Policy document establishes the terms under which we use and protect the information you provide when using the contact form on our website or sending us an email.",
        p2: "We are committed to the security of your data. When we ask you to fill out the contact form with personal information by which you can be identified, we do so ensuring that it will only be used in accordance with the terms of this document. However, this Privacy Policy may change over time or be updated, so we recommend and emphasize that you continuously review this page to ensure you agree with such changes."
      },
      responsible: {
        title: "Data Controller",
        content: "WOW Nautic, address: Puerto Deportivo de Fuengirola 45, 29640 Málaga, email: info@wownautic.com and Phone: +34 683 17 17 17."
      },
      dataCollected: {
        title: "Information Collected",
        content: "Our website may collect personal information, for example: Name, contact information such as your email address and/or phone number. Likewise, when necessary, specific information may be required, for example, to issue invoices."
      },
      dataUse: {
        title: "Use of Collected Information",
        content: "Our website uses the information in order to provide the best possible service, particularly to respond to messages you send us through the form or email, and to improve our products or services. We may occasionally send you emails through our site with special offers, new products and other advertising information that we consider relevant to you or that may provide you with some benefit. These emails will be sent to the address you provide and can be canceled at any time. We are highly committed to keeping your information secure. We use the most advanced systems and constantly update them to ensure that there is no unauthorized access."
      },
      retention: {
        title: "Data Retention Period",
        p1: "The personal data you provide will be kept until you request its deletion.",
        p2: "In the event that we do not maintain interactivity with you, we will keep them for a maximum period of five years, without prejudice to the possibility of exercising your rights in the terms indicated below.",
        p3: "In any case, the data retention period will be determined by the mandatory period set by commercial, accounting and tax regulations or other current regulations that establish a mandatory retention period greater than the above."
      },
      legal: {
        title: "Legal Basis for Processing Personal Data",
        content: "The legal basis or legitimacy for the processing of personal data provided through the website is the express consent requested for each of the processing purposes, the fulfillment of your expectations, as well as the execution of pre-contractual measures or a contract requested by you and legitimate interest."
      },
      thirdParty: {
        title: "Third Party Links",
        content: "This website may contain links to other sites that may be of interest to you. Once you click on these links and leave our page, we no longer have control over the site to which you will be redirected, and therefore we are not responsible for the terms or privacy or data protection on those other third-party sites. Such sites will have their own privacy policies, so it is advisable to consult them to confirm that you agree with them."
      },
      control: {
        title: "Control of Your Personal Information",
        content: "At any time you can write to us at the website email to restrict or cancel the collection or use of personal information you have provided us. We will never sell, transfer or distribute the personal information we collect without your consent, unless required by a judge with a court order. We reserve the right to change the terms of this Privacy Policy at any time, so we advise you to consult it when browsing our website."
      },
      sharing: {
        title: "Data Sharing",
        content: "Data will not be transferred to third parties, except with express authorization or legal obligation or permission."
      },
      rights: {
        title: "Rights Regarding Personal Data Processing",
        p1: "You may exercise, with respect to the data collected in the manner provided in this Privacy Policy, the rights recognized in data protection regulations and, in particular, the following rights: access, rectification, deletion, opposition, limitation and portability of personal data.",
        p2: "You have the right to access your personal data, as well as to request the rectification of inaccurate data or, where appropriate, request its deletion when, among other reasons, the data is no longer necessary for the purposes for which it was collected.",
        p3: "You will always have the possibility to revoke at any time the consent for any of the treatments for which you have given consent, without affecting the legality of the treatment based on the consent prior to its withdrawal.",
        p4: "You can exercise the rights referred to in the paragraph, duly indicating the reason for your claim, by written and signed request addressed to WOW Nautic – Puerto Deportivo de Fuengirola 45, 29640 Málaga or by sending an email to info@wownautic.com",
        p5: "Requests sent by email must be made from the email address registered by the applicant. In any case, in order for you to exercise the aforementioned rights and in order to offer guarantees about your identification as an applicant, you must attach to your request a copy of your National Identity Document or, where appropriate, Foreign Identification Number, in force.",
        p6: "Likewise, if you consider that your data has been treated inappropriately, you will have the right to file a complaint with the Spanish Data Protection Agency (C/ Jorge Juan, 6. 28001 – Madrid www.agpd.es)."
      },
      termsOfUse: {
        title: "Terms of Use",
        p1: "The use of the page grants user status and implies acceptance of the privacy policy. If you do not agree, you will refrain from using the page.",
        p2: "You are obliged and commit to use the page and its contents, in accordance with current legislation and with any notice contained on this page. The User is obliged and commits not to transmit, disseminate or make available to third parties any content of the website, such as information, texts, data, content, messages, graphics, drawings, sound and/or image files, photographs, videos, software, logos, brands, icons, technology, photographs, software, links, graphic design and source codes, or any other material to which you have access as a User of the Page, without this enumeration being limiting."
      }
    }
  },
  es: {
    nav: {
      offers: "Ofertas",
      howItWorks: "Cómo funciona",
      gallery: "Galería",
      testimonials: "Reseñas",
      faq: "Preguntas frecuentes",
      contact: "Contacto",
      bookNow: "Ver disponibilidad"
    },
    hero: {
      headline: "Alquiler Premium de Barcos y Motos de Agua en Fuengirola",
      subheadline: "Vive la mejor aventura en la Costa del Sol. Totalmente asegurado, guías certificados y recuerdos inolvidables.",
      ctaPrimary: "Ver disponibilidad",
      ctaSecondary: "Ver ofertas",
      badge: "N°1 en la Costa del Sol"
    },
    filters: {
      all: "Todos",
      jetskis: "Motos de agua",
      boats: "Barcos",
      sunset: "Atardecer",
      family: "Familia",
      private: "Privado"
    },
    offerCard: {
      duration: "Duración",
      capacity: "Capacidad",
      bookBtn: "Reservar ahora",
      detailsBtn: "Detalles",
      checkAvailability: "Consultar Disponibilidad",
      perGroup: "por grupo",
      perPerson: "por persona",
      guidedTour: "Tour guiado",
      selfGuided: "Autoguiado",
      minutes: "minutos",
      hour: "hora",
      hours: "horas",
      upTo: "Hasta",
      people: "personas",
      boatRental: "Alquiler de Barco",
      jetSki: "Moto de Agua",
      badgeBestseller: "MÁS VENDIDO",
      badgeNew: "NUEVO",
      badgePopular: "POPULAR",
      loading: "Cargando ofertas...",
      showAll: "Ver Todas las Ofertas",
      bundleBadge: "Varias duraciones",
      fromPrice: "Desde",
      fromDuration: "Desde",
      selectDuration: "Elige la duración"
    },
    socialProof: {
      fullyInsured: "Totalmente Asegurado",
      fullyInsuredDesc: "100% Seguro y Protegido",
      premiumFleet: "Flota Premium",
      premiumFleetDesc: "Barcos de Alta Calidad",
      expertCrew: "Tripulación Experta",
      expertCrewDesc: "Guías Certificados",
      topRated: "Mejor Valorado",
      topRatedDesc: "Reseñas 5 Estrellas"
    },
    howItWorks: {
      title: "Tu Aventura Comienza Aquí",
      subtitle: "Un proceso de reserva simple, seguro y sin complicaciones.",
      step1Title: "1. Elige Tu Aventura",
      step1Desc: "Explora nuestra flota de barcos y motos de agua premium. Selecciona la experiencia perfecta para tu grupo.",
      step2Title: "2. Reserva al Instante",
      step2Desc: "Consulta disponibilidad y reserva de forma segura en línea. Recibirás confirmación instantánea y detalles del punto de encuentro.",
      step3Title: "3. Disfruta del Paseo",
      step3Desc: "Encuéntranos en el puerto. Nuestro equipo se encargará de todo mientras tú creas recuerdos inolvidables."
    },
    sections: {
      offersTitle: "Nuestra Flota Premium",
      offersSubtitle: "Elige entre nuestra selección de barcos y motos de agua de alta gama",
      howItWorksTitle: "Cómo Funciona",
      safetyTitle: "Seguridad y Confianza",
      galleryTitle: "Galería",
      gallerySubtitle: "Momentos capturados en la Costa del Sol",
      galleryView: "Ver",
      testimonialsTitle: "Lo que dicen nuestros clientes",
      faqTitle: "Preguntas Frecuentes",
      locationTitle: "Encuéntranos en Fuengirola",
      finalCtaTitle: "¿Listo para tu aventura?",
      finalCtaSubtitle: "Reserva tu experiencia hoy y crea recuerdos para toda la vida.",
      finalCtaBtn: "Reservar Ahora"
    },
    welcome: {
      title: "Bienvenido al Puerto de Fuengirola,",
      titleHighlight: "Tu Aventura Comienza Aquí.",
      description: "Te damos la bienvenida a nuestra base en el Puerto Deportivo de Fuengirola. Nuestro equipo apasionado se dedica a hacer tu experiencia náutica inolvidable, con servicio personalizado y experiencia local.",
      feature1: "Ubicación Premium en el Puerto",
      feature2: "Equipo Local Experto",
      feature3: "Servicio Personalizado",
      feature4: "Experiencias Memorables",
      testimonial: "La cálida bienvenida del equipo marcó la diferencia. ¡Verdaderamente excepcional!",
      testimonialAuthor: "- Maria González, España"
    },
    faq: {
      q1: "¿Necesito licencia para alquilar un barco?",
      l1: "No se requiere licencia para embarcaciones de hasta 15 CV; briefing completo en el puerto.",
      a1: "Para embarcaciones de hasta 15hp, ¡no se requiere licencia! Proporcionamos instrucciones completas. Para barcos más grandes, se necesita una licencia válida, o puedes contratar uno de nuestros patrones profesionales.",
      q2: "¿El combustible está incluido en el precio?",
      l2: "El combustible está incluido en la mayoría de alquileres de 1–4 horas; día completo puede facturarse al regreso.",
      a2: "Para la mayoría de los alquileres (1-4 horas), el combustible está incluido. Para alquileres de día completo o embarcaciones de alto consumo, el combustible se cobra según el uso al regresar.",
      q3: "¿Cuál es la política de cancelación?",
      l3: "Cancelación gratuita hasta 24 h antes; mal tiempo = reembolso total o nueva fecha.",
      a3: "Ofrecemos cancelación gratuita hasta 24 horas antes de tu reserva. Las cancelaciones por mal tiempo se reembolsan completamente o se reprograman.",
      q4: "¿Hay una edad mínima para las motos de agua?",
      l4: "Conductores 18+ (16 con autorización parental); pasajeros desde unos 6 años.",
      a4: "Los conductores deben tener 18+ años (o 16 con consentimiento parental). Los pasajeros pueden ser más jóvenes, generalmente mayores de 6 años dependiendo de las condiciones.",
      q5: "¿Dónde está el punto de encuentro?",
      l5: "Puerto Deportivo de Fuengirola — recibirás el muelle exacto en la confirmación.",
      a5: "Estamos ubicados en el Puerto Deportivo de Fuengirola. Recibirás el número exacto del muelle y la ubicación de Google Maps en tu confirmación de reserva.",
      q6: "¿Puedo alquilar una moto de agua sin licencia náutica?",
      l6: "Sí — incluye instructor certificado; no se requiere licencia.",
      a6: "Las motos de agua en Wownautic incluyen supervisión profesional. No se necesita licencia náutica; el conductor debe cumplir la edad mínima y el briefing de seguridad.",
      q7: "¿Cuándo está disponible la excursión de delfines?",
      l7: "Las excursiones salen desde Fuengirola en temporada; duración y precio según oferta en el catálogo.",
      a7: "Nuestros avistamientos de delfines parten del Puerto de Fuengirola. La temporada depende del mar y la fauna; consulta cada ficha para duración, horario y precio TTC.",
      q8: "¿Qué pasa si hace mal tiempo el día de mi reserva?",
      l8: "Tiempo peligroso = reprogramación gratuita o reembolso total; te avisamos si hay cambio.",
      a8: "Si el capitán cancela por seguridad (viento fuerte, tormenta), reembolso íntegro o nueva reserva gratis. Lluvia ligera puede no cancelar salidas cortas; confirmamos por teléfono o WhatsApp."
    },
    geo: {
      homeSummary: "Wownautic alquila barcos y motos de agua en el Puerto Deportivo de Fuengirola (Costa del Sol, Málaga). Reserva online, tripulación profesional, sin licencia para motos de agua. Desde {{minPrice}}€ TTC.",
      homeSummaryFallback: "Wownautic alquila barcos y motos de agua en el Puerto Deportivo de Fuengirola (Costa del Sol, Málaga). Reserva online, tripulación profesional, sin licencia para motos de agua.",
      offerSummary: "{{title}}: {{duration}}, {{price}}€ TTC, hasta {{capacity}} personas, salida Puerto de Fuengirola, Costa del Sol."
    },
    offer: {
      inclusions: {
        captain: "Capitán profesional",
        safety: "Equipo de seguridad",
        drinks: "Bebidas incluidas",
        insurance: "Seguro completo"
      },
      goodToKnow: {
        meeting: "Punto de partida:",
        meetingValue: "Puerto Deportivo de Fuengirola",
        language: "Idioma:",
        languageValue: "English, Español, Français",
        cancellation: "Cancelación:",
        cancellationValue: "Gratuita hasta 24 h antes"
      },
      aboutTitle: "Acerca de la experiencia",
      includedTitle: "Qué está incluido",
      goodToKnowTitle: "Bueno saber",
      imageAlt: "{{title}} en Puerto Deportivo Fuengirola — foto {{index}}"
    },
    gallery: {
      altJetSki: "Alquiler moto de agua Puerto Deportivo Fuengirola",
      altBoatTour: "Excursión en barco desde Fuengirola",
      altDolphins: "Excursión avistamiento delfines Costa del Sol",
      altSpeedboat: "Lancha rápida Fuengirola Marina",
      altPartyBoat: "Barco fiesta charter Fuengirola",
      altMarina: "Embarcaciones Wownautic Fuengirola",
      altSunset: "Paseo en barco atardecer Costa del Sol",
      altFishing: "Barco pesca Fuengirola",
      altGroup: "Experiencia en barco grupo Wownautic",
      altCoast: "Paseo costa Fuengirola Málaga",
      altTrolling: "Pesca trolling Costa del Sol",
      altFamily: "Alquiler barco familia Fuengirola"
    },
    location: {
      description: "Visítanos en el corazón del Puerto Deportivo de Fuengirola. Fácil aparcamiento e instalaciones accesibles.",
      address: "Dirección",
      addressLine1: "Puerto Deportivo de Fuengirola, Local 45",
      addressLine2: "29640 Fuengirola, Málaga",
      phone: "Teléfono / WhatsApp",
      email: "Email",
      hours: "Horario de Apertura",
      hoursValue: "Lun - Dom: 10:00 - 20:00",
      mapButton: "Abrir en Google Maps"
    },
    contact: {
      title: "Información de contacto",
      formTitle: "Déjanos un mensaje",
      phoneLabel: "Número de teléfono",
      emailLabel: "Dirección de correo",
      addressLabel: "Dirección de oficina",
      firstName: "Nombre",
      lastName: "Apellido",
      emailPlaceholder: "Correo Electrónico",
      subject: "Asunto",
      message: "Tu Mensaje",
      send: "Enviar",
      sending: "Enviando...",
      successMessage: "¡Mensaje enviado con éxito! Te responderemos pronto.",
      errorMessage: "Error al enviar el mensaje. Inténtalo de nuevo o contáctanos directamente."
    },
    footer: {
      copyright: " 2026 Wow Nautic. Todos los derechos reservados.",
      privacy: "Política de Privacidad",
      terms: "Términos de Servicio",
      description: "Servicios premium de alquiler de barcos en la Costa del Sol. Creando recuerdos inolvidables desde 2024.",
      quickLinks: "Enlaces Rápidos",
      offers: "Ofertas",
      gallery: "Galería",
      contact: "Contacto",
      faq: "FAQ",
      legal: "Legal",
      cookiePolicy: "Política de Cookies",
      newsletter: "Mantente Informado",
      emailPlaceholder: "Introduce tu email",
      subscribe: "Suscribirse",
      subscribing: "Suscribiendo...",
      newsletterCheckEmail: "¡Revisa tu bandeja de entrada para confirmar tu suscripción!",
      newsletterConfirmed: "¡Tu email ha sido confirmado! ¡Bienvenido a bordo!",
      newsletterAlreadyVerified: "¡Ya estás suscrito!",
      newsletterInvalid: "Enlace de verificación no válido.",
      newsletterInvalidEmail: "Por favor, introduce un email válido.",
      newsletterError: "Ha ocurrido un error. Por favor, inténtalo de nuevo."
    },
    search: {
      resourceType: "Reservo un",
      boat: "Barco",
      jetski: "Moto de agua",
      persons: "Número de personas",
      person: "persona",
      people: "personas",
      searchBtn: "Buscar",
      resultsTitle: "Ofertas disponibles",
      noResults: "Ninguna oferta coincide con tu búsqueda. Prueba con otros criterios."
    },
    stickyMobile: {
      viewOffers: "Ver Ofertas",
      checkAvailability: "Ver Disponibilidad"
    },
    whatsApp: {
      chatWithUs: "¡Escríbenos!"
    },
    chatWidget: {
      chatWithUs: "¡Escríbenos!",
      online: "En línea",
      placeholder: "Escribe tu mensaje...",
      welcomeMessage: "¡Hola! 👋 ¿En qué puedo ayudarte? No dudes en preguntar sobre nuestros barcos, motos de agua o cualquier servicio.",
      errorMessage: "Lo sentimos, ha ocurrido un error. Inténtalo de nuevo.",
      ariaLabel: "Abrir chat",
      newConversation: "Nuevo chat",
      newConversationTitle: "Iniciar una nueva conversación",
      dictationStart: "Dictar mensaje",
      dictationStop: "Detener dictado",
      dictationNotSupported: "La entrada por voz no está disponible en este navegador (prueba Chrome o Edge)."
    },
    booking: {
      title: "Consultar Disponibilidad",
      subtitle: "Rellena el formulario y te responderemos en menos de 30 minutos.",
      selectParticipants: "Selecciona el Número de Participantes",
      selectDate: "Selecciona la Fecha",
      continueToTime: "Continuar a Selección de Horario",
      selectedDate: "Fecha Seleccionada",
      change: "Cambiar",
      availableSlots: "Horarios Disponibles",
      noSlots: "No hay horarios disponibles para esta fecha. Por favor, selecciona otra fecha.",
      spotsLeft: "plaza disponible",
      spotsLeftPlural: "plazas disponibles",
      back: "Atrás",
      continueToDetails: "Continuar a Detalles",
      summary: "Resumen",
      edit: "Editar",
      date: "Fecha",
      time: "Hora",
      participants: "Participantes",
      total: "Total",
      firstName: "Nombre",
      lastName: "Apellido",
      email: "Email",
      phone: "Teléfono",
      couponCode: "Código promocional",
      couponPlaceholder: "Introduce tu código promocional",
      couponValidating: "Validando código...",
      couponApplied: "Código aplicado",
      couponInvalid: "Código no válido",
      couponReasonExpired: "Este código promocional ha caducado.",
      couponReasonOfferNotAllowed: "Este código no es válido para esta oferta.",
      couponReasonQuotaExhausted: "Este código promocional ya no está disponible.",
      couponReasonCustomerEmailRequired: "Introduce tu email para validar este código.",
      couponReasonMinOrder: "No se alcanza el importe mínimo para este código.",
      couponReasonNotStarted: "Este código promocional aún no está activo.",
      couponReasonBookingPeriod: "Este código promocional no es válido para la fecha de reserva seleccionada.",
      discount: "Descuento",
      continueToPayment: "Continuar al Pago",
      processing: "Procesando...",
      bookingSummary: "Resumen de Reserva",
      name: "Nombre",
      backToDetails: "Volver a detalles",
      expiryWarning: "Tu reserva expirará en 15 minutos si no se completa el pago.",
      paymentOverlayTitle: "Procesando tu pago",
      paymentOverlayMessage: "Espera mientras procesamos tu pago de forma segura. No cierres esta página.",
      paymentOverlayConfirmTitle: "Confirmando tu reserva",
      paymentOverlayConfirmMessage: "¡Pago recibido! Estamos finalizando tu reserva con WowBooking."
    },
    bookingConfirmation: {
      title: "Reserva confirmada",
      subtitle: "Gracias por elegir Wownautic. ¡Tu aventura está reservada!",
      processing: "Confirmando tu pago...",
      success: "Tu reserva está confirmada. Recibirás un email de confirmación en breve.",
      errorTitle: "Problema con el pago",
      paymentFailed: "El pago no se completó. Por favor, inténtalo de nuevo.",
      paymentIncomplete: "El pago aún se está procesando. Contáctanos si se te ha cobrado.",
      confirmError: "Pago recibido pero no se pudo confirmar la reserva. Contacta con soporte.",
      missingBooking: "Enlace de confirmación no válido. Contacta con soporte.",
      backHome: "Volver al inicio",
      contactUs: "Contáctanos",
      referenceLabel: "Referencia de reserva",
      detailsTitle: "Tu reserva",
      experience: "Experiencia",
      date: "Fecha",
      time: "Horario",
      participants: "Participantes",
      equipment: "Equipo",
      guest: "Nombre",
      email: "Email",
      phone: "Teléfono",
      subtotal: "Subtotal",
      discount: "Descuento",
      totalPaid: "Total pagado",
      meetingTitle: "Punto de encuentro",
      meetingPoint: "Puerto Deportivo de Fuengirola, Costa del Sol",
      meetingHint: "El amarre exacto y el enlace de Google Maps están en tu email de confirmación.",
      emailNotice: "Hemos enviado un email de confirmación con todos los detalles a {{email}}."
    },
    contactConfirmation: {
      title: "Mensaje enviado",
      subtitle: "Gracias por contactar con Wownautic. Hemos recibido tu mensaje y te responderemos lo antes posible.",
      emailNotice: "Si tu consulta es urgente, también puedes llamarnos al +34 683 17 17 17.",
      backHome: "Volver al inicio",
      sendAnother: "Enviar otro mensaje"
    },
    newsletterConfirmation: {
      titlePending: "Revisa tu bandeja de entrada",
      subtitlePending: "Te hemos enviado un email de confirmación. Haz clic en el enlace del email para completar tu suscripción.",
      titleConfirmed: "Suscripción confirmada",
      subtitleConfirmed: "¡Tu email ha sido confirmado! Bienvenido a bordo — recibirás nuestras últimas ofertas y noticias.",
      titleAlreadyVerified: "Ya estás suscrito",
      subtitleAlreadyVerified: "Tu email ya está en nuestra lista de newsletter.",
      titleInvalid: "Enlace no válido",
      subtitleInvalid: "Este enlace de verificación no es válido o ha caducado.",
      titleError: "Algo salió mal",
      subtitleError: "Se produjo un error al confirmar tu suscripción. Por favor, inténtalo de nuevo.",
      backHome: "Volver al inicio",
      browseOffers: "Ver nuestras ofertas"
    },
    cookiePolicy: {
      title: "Política de Cookies",
      whatAreCookies: {
        title: "¿Qué es una Cookie?",
        description: "Una cookie es un pequeño fichero de texto que se almacena en su navegador cuando visita casi cualquier página web. Su utilidad es que la web sea capaz de recordar su visita cuando vuelva a navegar por esa página. Las cookies suelen almacenar información de carácter técnico, preferencias personales, personalización de contenidos, estadísticas de uso, enlaces a redes sociales, acceso a cuentas de usuario, etc. El objetivo de la cookie es adaptar el contenido de la web a su perfil y necesidades, sin cookies los servicios ofrecidos por cualquier página se verían mermados notablemente.",
        moreInfo: "Si desea consultar más información sobre qué son las cookies, qué almacenan, cómo eliminarlas, desactivarlas, etc., le rogamos vea este documento."
      },
      cookiesUsed: {
        title: "Cookies Utilizadas en Este Sitio Web",
        intro: "Siguiendo las directrices de la Agencia Española de Protección de Datos procedemos a detallar el uso de cookies que hace esta web con el fin de informarle con la máxima exactitud posible.",
        ownCookies: {
          title: "Este sitio web utiliza las siguientes cookies propias:",
          session: "Cookies de sesión, para garantizar que los usuarios que escriban comentarios en el blog sean humanos y no aplicaciones automatizadas. De esta forma se combate el spam."
        },
        thirdPartyCookies: {
          title: "Este sitio web utiliza las siguientes cookies de terceros:",
          analytics: "Almacena cookies para poder elaborar estadísticas sobre el tráfico y volumen de visitas de esta web. Al utilizar este sitio web está consintiendo el tratamiento de información acerca de usted por Google. Por tanto, el ejercicio de cualquier derecho en este sentido deberá hacerlo comunicando directamente con Google.",
          socialMedia: {
            title: "Redes Sociales",
            description: "Cada red social utiliza sus propias cookies para que usted pueda pinchar en botones del tipo Me gusta o Compartir."
          }
        }
      },
      disableDelete: {
        title: "Desactivación o Eliminación de Cookies",
        description: "En cualquier momento podrá ejercer su derecho de desactivación o eliminación de cookies de este sitio web. Estas acciones se realizan de forma diferente en función del navegador que esté usando. Guía para desactivar las cookies en los navegadores más populares."
      },
      additionalNotes: {
        title: "Notas Adicionales",
        note1: "Ni este sitio web ni sus representantes legales son responsables del contenido o veracidad de las políticas de privacidad que puedan tener los terceros mencionados en esta política de cookies.",
        note2: "Los navegadores web son las herramientas encargadas de almacenar las cookies y desde este lugar debe efectuar su derecho a eliminación o desactivación de las mismas. Ni este sitio web ni sus representantes legales pueden garantizar la correcta o incorrecta manipulación de las cookies por parte de los mencionados navegadores.",
        note3: "En algunos casos es necesario instalar cookies para que el navegador no olvide su decisión de no aceptación de las mismas.",
        note4: "En el caso de las cookies de Google Analytics, esta empresa almacena las cookies en servidores ubicados en Estados Unidos y se compromete a no compartirla con terceros, excepto en los casos en los que sea necesario para el funcionamiento del sistema o cuando la ley obligue a tal efecto. Según Google no guarda su dirección IP. Google Inc. es una compañía adherida al Acuerdo de Puerto Seguro que garantiza que todos los datos transferidos serán tratados con un nivel de protección acorde a la normativa europea. Si desea información sobre el uso que Google da a las cookies le adjuntamos este otro enlace."
      },
      contact: "Para cualquier duda o consulta acerca de esta política de cookies no dudes en comunicarte con nosotros a través de la sección de contacto."
    },
    privacyPolicy: {
      title: "Política de Privacidad",
      intro: {
        p1: "El presente documento de Política de Privacidad establece los términos en que usamos y protegemos la información que nos proporciones al usar el formulario de contacto de nuestra web o enviarnos un email.",
        p2: "Estamos comprometidos con la seguridad de tus datos. Cuando te pedimos que rellenes el formulario de contacto con información personal con la cual puedes ser identificado, lo hacemos asegurando que sólo se empleará de acuerdo con los términos de este documento. Sin embargo, esta Política de Privacidad puede cambiar con el tiempo o ser actualizada por lo que le recomendamos y enfatizamos revisar continuamente esta página para asegurarse que está de acuerdo con dichos cambios."
      },
      responsible: {
        title: "Responsable",
        content: "WOW Nautic, dirección: Puerto Deportivo de Fuengirola 45, 29640 Málaga, email: info@wownautic.com y Telf.: +34 683 17 17 17."
      },
      dataCollected: {
        title: "Información Recogida",
        content: "Nuestro sitio web podrá recoger información personal, por ejemplo: Nombre, información de contacto como su dirección de correo electrónico y/o teléfono. Así mismo cuando sea necesario podrá ser requerida información específica para, por ej. realizar facturas."
      },
      dataUse: {
        title: "Uso de la Información Recogida",
        content: "Nuestro sitio web emplea la información con el fin de proporcionar el mejor servicio posible, particularmente para responder a los mensajes que nos envíes a través de formulario o email, y mejorar nuestros productos o servicios. Es posible que le enviemos correos electrónicos puntualmente a través de nuestro sitio con ofertas especiales, nuevos productos y otra información publicitaria que consideremos relevante para usted o que pueda brindarle algún beneficio, estos correos electrónicos serán enviados a la dirección que usted proporcione y podrán ser cancelados en cualquier momento. Estamos altamente comprometidos en cumplir con el compromiso de mantener tu información segura. Usamos los sistemas más avanzados y los actualizamos constantemente para asegurarnos que no exista ningún acceso no autorizado."
      },
      retention: {
        title: "Tiempo de Conservación de sus Datos",
        p1: "Los datos personales que nos proporciones se conservarán mientras no solicites su supresión.",
        p2: "En el caso de no mantener contigo una interactividad, los mantendremos por un período máximo de cinco años, sin perjuicio de la posibilidad de ejercer tus derechos en los términos que se indican más adelante.",
        p3: "En todo caso, el plazo de conservación de los datos vendrá determinado por el plazo obligatorio marcado por la normativa mercantil, contable y fiscal u otra normativa vigente que establezca de manera obligatoria un plazo de conservación mayor a los anteriores."
      },
      legal: {
        title: "Legitimación para el Tratamiento de sus Datos Personales",
        content: "La base legal o legitimación para el tratamiento de los datos personales facilitados a través de la web es el consentimiento expreso que se te solicita para cada una de las finalidades de tratamiento, el cumplimiento de sus expectativas, así como la ejecución de medidas precontractuales o de un contrato solicitado por ti y el interés legítimo."
      },
      thirdParty: {
        title: "Enlaces a Terceros",
        content: "Este sitio web pudiera contener enlaces a otros sitios que pudieran ser de tu interés. Una vez que hagas clic en estos enlaces y abandones nuestra página, ya no tenemos control sobre el sitio al que serás redirigido, y por lo tanto no somos responsables de los términos o privacidad ni de la protección de los datos en esos otros sitios terceros. Dichos sitios tendrás sus propias políticas de privacidad por lo cual es recomendable que los consultes para confirmar que estás de acuerdo con ellas."
      },
      control: {
        title: "Control de su Información Personal",
        content: "En cualquier momento puedes escribirnos al email de la web para restringir o cancelar la recopilación o el uso de la información personal que nos has proporcionado. Nunca venderemos, cederemos ni distribuiremos la información personal que recopilemos sin su consentimiento, salvo que sea requerido por un juez con un orden judicial. Nos reservamos el derecho de cambiar los términos de la presente Política de Privacidad en cualquier momento, por lo que aconsejamos que la consultes cuando navegues en nuestra web."
      },
      sharing: {
        title: "Cesión de Datos",
        content: "No se cederán datos a terceros, salvo autorización expresa u obligación o permiso legal."
      },
      rights: {
        title: "Derechos en Relación con el Tratamiento de Datos Personales",
        p1: "Podrá ejercer, respecto de los datos recabados en la forma prevista en la presente Política de Privacidad, los derechos reconocidos en la normativa de protección de datos y, en particular, los siguientes derechos: acceso, rectificación, supresión, oposición, limitación y portabilidad de los datos personales.",
        p2: "Tiene derecho a acceder a sus datos personales, así como a solicitar la rectificación de los datos inexactos o, en su caso, solicitar su supresión cuando entre otros motivos, los datos ya no sean necesarios para los fines que fueron recogidos.",
        p3: "Siempre tendrá la posibilidad de revocar en cualquier momento el consentimiento para cualquiera de los tratamientos para los que ha otorgado consentimiento, sin que ello afecte a la licitud del tratamiento basado en el consentimiento previo a su retirada.",
        p4: "Puede ejercer los derechos referidos en el párrafo, indicando debidamente el motivo de su pretensión, mediante solicitud escrita y firmada dirigida a WOW Nautic – Puerto Deportivo de Fuengirola 45, 29640 Málaga o bien mediante el envío de un correo electrónico a la dirección info@wownautic.com",
        p5: "Las solicitudes enviadas por correo electrónico deberán realizarse desde la dirección de correo registrada por el solicitante. En todo caso, para que ejerzas los citados derechos y al objeto de ofrecer garantías sobre tu identificación como solicitante, deberás acompañar a tu solicitud copia de tu Documento Nacional de Identidad o, en su caso, Número de Identificación de Extranjeros, en vigor.",
        p6: "Asimismo, si consideras que sus datos han sido tratados de forma inadecuada, tendrá derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (C/ Jorge Juan, 6. 28001 – Madrid www.agpd.es)."
      },
      termsOfUse: {
        title: "Condiciones de Uso",
        p1: "La utilización de la página otorga la utilización de usuario e implica la aceptación de la política de privacidad. Si no estuvieras conforme, se abstendrá de utilizar la página.",
        p2: "Estás obligado y te compromete a usar la página y sus contenidos, de conformidad con la legislación vigente y con cualquier aviso contenido en esta página. El Usuario se obliga y se compromete a no transmitir, difundir o poner a disposición de terceros cualquier contenido de la web, como informaciones, textos, datos, contenidos, mensajes, gráficos, dibujos, archivos de sonido y/o imagen, fotografías, videos, software, logotipos, marcas, iconos, tecnología, fotografías, software, enlaces, diseño gráfico y códigos fuente, o cualquier otro material al que tuviera acceso en su condición de Usuario de la Página, sin que esta enumeración tenga carácter limitativo."
      }
    }
  },
  fr: {
    nav: {
      offers: "Offres",
      howItWorks: "Comment ça marche",
      gallery: "Galerie",
      testimonials: "Avis Clients",
      faq: "FAQ",
      contact: "Contact",
      bookNow: "Voir disponibilités"
    },
    hero: {
      headline: "Location de Bateaux et Jet Skis Premium à Fuengirola",
      subheadline: "Vivez l'aventure ultime sur la Costa del Sol. Entièrement assuré, guides certifiés et souvenirs inoubliables.",
      ctaPrimary: "Voir disponibilités",
      ctaSecondary: "Voir les offres",
      badge: "N°1 sur la Costa del Sol"
    },
    filters: {
      all: "Tous",
      jetskis: "Jet Skis",
      boats: "Bateaux",
      sunset: "Coucher de soleil",
      family: "Famille",
      private: "Privé"
    },
    offerCard: {
      duration: "Durée",
      capacity: "Capacité",
      bookBtn: "Réserver maintenant",
      detailsBtn: "Détails",
      checkAvailability: "Vérifier Disponibilité",
      perGroup: "par groupe",
      perPerson: "par personne",
      guidedTour: "Visite guidée",
      selfGuided: "Autoguidé",
      minutes: "minutes",
      hour: "heure",
      hours: "heures",
      upTo: "Jusqu'à",
      people: "personnes",
      boatRental: "Location de Bateau",
      jetSki: "Jet Ski",
      badgeBestseller: "BEST-SELLER",
      badgeNew: "NOUVEAU",
      badgePopular: "POPULAIRE",
      loading: "Chargement des offres...",
      showAll: "Voir Toutes les Offres",
      bundleBadge: "Plusieurs durées",
      fromPrice: "À partir de",
      fromDuration: "À partir de",
      selectDuration: "Choisissez la durée"
    },
    socialProof: {
      fullyInsured: "Entièrement Assuré",
      fullyInsuredDesc: "100% Sûr et Sécurisé",
      premiumFleet: "Flotte Premium",
      premiumFleetDesc: "Bateaux Haut de Gamme",
      expertCrew: "Équipage Expert",
      expertCrewDesc: "Guides Certifiés",
      topRated: "Mieux Noté",
      topRatedDesc: "Avis 5 Étoiles"
    },
    howItWorks: {
      title: "Votre Aventure Commence Ici",
      subtitle: "Un processus de réservation simple, sécurisé et fluide.",
      step1Title: "1. Choisissez Votre Aventure",
      step1Desc: "Parcourez notre flotte de bateaux et jet skis premium. Sélectionnez l'expérience parfaite pour votre groupe.",
      step2Title: "2. Réservez Instantanément",
      step2Desc: "Vérifiez la disponibilité et réservez en ligne en toute sécurité. Vous recevrez une confirmation instantanée et les détails du point de rendez-vous.",
      step3Title: "3. Profitez de la Balade",
      step3Desc: "Retrouvez-nous au port. Notre équipe s'occupe de tout pendant que vous créez des souvenirs inoubliables."
    },
    sections: {
      offersTitle: "Notre Flotte Premium",
      offersSubtitle: "Choisissez parmi notre sélection de bateaux et jet skis haut de gamme",
      howItWorksTitle: "Comment Ça Marche",
      safetyTitle: "Sécurité et Confiance",
      galleryTitle: "Galerie",
      gallerySubtitle: "Moments capturés sur la Costa del Sol",
      galleryView: "Voir",
      testimonialsTitle: "Ce que disent nos clients",
      faqTitle: "Questions Fréquentes",
      locationTitle: "Nous Trouver à Fuengirola",
      finalCtaTitle: "Prêt pour votre aventure ?",
      finalCtaSubtitle: "Réservez votre expérience aujourd'hui et créez des souvenirs inoubliables.",
      finalCtaBtn: "Réserver Maintenant"
    },
    welcome: {
      title: "Bienvenue au Port de Fuengirola,",
      titleHighlight: "Votre Aventure Commence Ici.",
      description: "Nous vous accueillons chaleureusement dans notre base au Port de Plaisance de Fuengirola. Notre équipe passionnée se consacre à rendre votre expérience nautique inoubliable, avec un service personnalisé et une expertise locale.",
      feature1: "Emplacement Premium au Port",
      feature2: "Équipe Locale Experte",
      feature3: "Service Personnalisé",
      feature4: "Expériences Mémorables",
      testimonial: "L'accueil chaleureux de l'équipe a fait toute la différence. Vraiment exceptionnel !",
      testimonialAuthor: "- Maria González, Espagne"
    },
    faq: {
      q1: "Ai-je besoin d'un permis pour louer un bateau ?",
      l1: "Aucun permis pour les bateaux jusqu'à 15 CV ; briefing complet sur place.",
      a1: "Pour les bateaux jusqu'à 15cv, aucun permis n'est requis ! Nous fournissons des instructions complètes. Pour les bateaux plus grands, un permis valide est nécessaire, ou vous pouvez engager l'un de nos skippers professionnels.",
      q2: "Le carburant est-il inclus dans le prix ?",
      l2: "Carburant inclus sur la plupart des locations 1–4 h ; journée complète facturée au retour si besoin.",
      a2: "Pour la plupart des locations (1-4 heures), le carburant est inclus. Pour les locations à la journée ou les bateaux à forte consommation, le carburant est facturé en fonction de l'utilisation au retour.",
      q3: "Quelle est la politique d'annulation ?",
      l3: "Annulation gratuite jusqu'à 24 h avant ; mauvais temps = remboursement ou report.",
      a3: "Nous offrons une annulation gratuite jusqu'à 24 heures avant votre réservation. Les annulations pour mauvais temps sont entièrement remboursées ou reprogrammées.",
      q4: "Y a-t-il un âge minimum pour les jet skis ?",
      l4: "Conducteurs 18+ (16 ans avec accord parental) ; passagers dès environ 6 ans.",
      a4: "Les conducteurs doivent avoir 18 ans et plus (ou 16 ans avec consentement parental). Les passagers peuvent être plus jeunes, généralement 6 ans et plus selon les conditions.",
      q5: "Où est le point de rendez-vous ?",
      l5: "Puerto Deportivo de Fuengirola — numéro de quai envoyé dans la confirmation.",
      a5: "Nous sommes situés au Puerto Deportivo de Fuengirola. Vous recevrez le numéro exact du quai et l'emplacement Google Maps dans votre confirmation de réservation.",
      q6: "Puis-je louer un jet ski sans permis bateau ?",
      l6: "Oui — séance avec moniteur certifié ; aucun permis requis.",
      a6: "Les jet skis Wownautic incluent un encadrement professionnel. Aucun permis n'est requis ; le conducteur doit respecter l'âge minimum et le briefing sécurité.",
      q7: "Quand a lieu l'excursion dauphins ?",
      l7: "Départs depuis Fuengirola en saison ; durée et tarif selon l'offre du catalogue.",
      a7: "Nos sorties dauphins partent du port de Fuengirola. La saison dépend de la mer et de la faune ; voir chaque fiche pour durée, horaires et prix TTC.",
      q8: "Que se passe-t-il si la météo est mauvaise le jour de la réservation ?",
      l8: "Conditions dangereuses = report gratuit ou remboursement intégral ; nous vous contactons.",
      a8: "Si le capitaine annule pour sécurité (vent fort, orage), remboursement total ou nouvelle date gratuite. Pluie légère peut ne pas annuler une courte sortie ; confirmation par téléphone ou WhatsApp."
    },
    geo: {
      homeSummary: "Wownautic propose location de bateaux et jet skis au Port de Fuengirola (Costa del Sol, Málaga). Réservation en ligne, encadrement pro, sans permis pour les jet skis. À partir de {{minPrice}}€ TTC.",
      homeSummaryFallback: "Wownautic propose location de bateaux et jet skis au Port de Fuengirola (Costa del Sol, Málaga). Réservation en ligne, encadrement pro, sans permis pour les jet skis.",
      offerSummary: "{{title}} : {{duration}}, {{price}}€ TTC, max {{capacity}} pers., départ Fuengirola Marina, Costa del Sol."
    },
    offer: {
      inclusions: {
        captain: "Capitaine professionnel",
        safety: "Équipement de sécurité",
        drinks: "Boissons incluses",
        insurance: "Assurance complète"
      },
      goodToKnow: {
        meeting: "Point de départ :",
        meetingValue: "Puerto Deportivo de Fuengirola",
        language: "Langue :",
        languageValue: "English, Español, Français",
        cancellation: "Annulation :",
        cancellationValue: "Gratuite jusqu'à 24 h avant"
      },
      aboutTitle: "À propos de l'expérience",
      includedTitle: "Ce qui est inclus",
      goodToKnowTitle: "Bon à savoir",
      imageAlt: "{{title}} au Port de Fuengirola — photo {{index}}"
    },
    gallery: {
      altJetSki: "Location jet ski Port de Fuengirola Costa del Sol",
      altBoatTour: "Excursion bateau depuis Fuengirola",
      altDolphins: "Excursion dauphins Costa del Sol",
      altSpeedboat: "Speedboat Fuengirola Marina",
      altPartyBoat: "Bateau fête charter Fuengirola",
      altMarina: "Bateaux Wownautic Fuengirola Marina",
      altSunset: "Croisière coucher de soleil Costa del Sol",
      altFishing: "Sortie pêche Fuengirola",
      altGroup: "Sortie bateau groupe Wownautic",
      altCoast: "Balade côtière Fuengirola Málaga",
      altTrolling: "Pêche à la traîne Costa del Sol",
      altFamily: "Location bateau famille Fuengirola"
    },
    location: {
      description: "Visitez-nous au cœur du Port de Plaisance de Fuengirola. Parking facile et installations accessibles.",
      address: "Adresse",
      addressLine1: "Puerto Deportivo de Fuengirola, Local 45",
      addressLine2: "29640 Fuengirola, Málaga",
      phone: "Téléphone / WhatsApp",
      email: "Email",
      hours: "Horaires d'Ouverture",
      hoursValue: "Lun - Dim : 10h00 - 20h00",
      mapButton: "Ouvrir dans Google Maps"
    },
    contact: {
      title: "Informations de contact",
      formTitle: "Laissez-nous un message",
      phoneLabel: "Numéro de téléphone",
      emailLabel: "Adresse email",
      addressLabel: "Adresse du bureau",
      firstName: "Prénom",
      lastName: "Nom",
      emailPlaceholder: "Adresse Email",
      subject: "Sujet",
      message: "Votre Message",
      send: "Envoyer",
      sending: "Envoi en cours...",
      successMessage: "Message envoyé avec succès ! Nous vous répondrons bientôt.",
      errorMessage: "Échec de l'envoi du message. Veuillez réessayer ou nous contacter directement."
    },
    footer: {
      copyright: " 2026 Wow Nautic. Tous droits réservés.",
      privacy: "Politique de Confidentialité",
      terms: "Conditions d'Utilisation",
      description: "Services de location de bateaux premium sur la Costa del Sol. Créant des souvenirs inoubliables depuis 2024.",
      quickLinks: "Liens Rapides",
      offers: "Offres",
      gallery: "Galerie",
      contact: "Contact",
      faq: "FAQ",
      legal: "Légal",
      cookiePolicy: "Politique des Cookies",
      newsletter: "Restez Informé",
      emailPlaceholder: "Entrez votre email",
      subscribe: "S'abonner",
      subscribing: "Inscription...",
      newsletterCheckEmail: "Vérifiez votre boîte mail pour confirmer votre inscription !",
      newsletterConfirmed: "Votre email a été confirmé ! Bienvenue à bord !",
      newsletterAlreadyVerified: "Vous êtes déjà inscrit !",
      newsletterInvalid: "Lien de vérification invalide.",
      newsletterInvalidEmail: "Veuillez entrer un email valide.",
      newsletterError: "Une erreur est survenue. Veuillez réessayer."
    },
    search: {
      resourceType: "Je réserve un",
      boat: "Bateau",
      jetski: "Jet Ski",
      persons: "Nombre de personnes",
      person: "personne",
      people: "personnes",
      searchBtn: "Chercher",
      resultsTitle: "Offres disponibles",
      noResults: "Aucune offre ne correspond à votre recherche. Essayez d'autres critères."
    },
    stickyMobile: {
      viewOffers: "Voir les Offres",
      checkAvailability: "Voir Disponibilités"
    },
    whatsApp: {
      chatWithUs: "Discutez avec nous !"
    },
    chatWidget: {
      chatWithUs: "Discutez avec nous !",
      online: "En ligne",
      placeholder: "Tapez votre message...",
      welcomeMessage: "Bonjour ! 👋 Comment puis-je vous aider ? N'hésitez pas à poser vos questions sur nos bateaux, jet-skis ou tout autre service.",
      errorMessage: "Désolé, une erreur s'est produite. Veuillez réessayer.",
      ariaLabel: "Ouvrir le chat",
      newConversation: "Nouvelle conversation",
      newConversationTitle: "Repartir de zéro (nouvelle conversation côté Totemium)",
      dictationStart: "Dicter le message",
      dictationStop: "Arrêter la dictée",
      dictationNotSupported: "La saisie vocale n'est pas disponible dans ce navigateur (essayez Chrome ou Edge)."
    },
    booking: {
      title: "Vérifier la Disponibilité",
      subtitle: "Remplissez le formulaire ci-dessous et nous vous répondrons dans les 30 minutes.",
      selectParticipants: "Sélectionnez le Nombre de Participants",
      selectDate: "Sélectionnez la Date",
      continueToTime: "Continuer vers la Sélection d'Horaire",
      selectedDate: "Date Sélectionnée",
      change: "Modifier",
      availableSlots: "Créneaux Horaires Disponibles",
      noSlots: "Aucun créneau disponible pour cette date. Veuillez sélectionner une autre date.",
      spotsLeft: "place disponible",
      spotsLeftPlural: "places disponibles",
      back: "Retour",
      continueToDetails: "Continuer vers les Détails",
      summary: "Récapitulatif",
      edit: "Modifier",
      date: "Date",
      time: "Heure",
      participants: "Participants",
      total: "Total",
      firstName: "Prénom",
      lastName: "Nom",
      email: "Email",
      phone: "Téléphone",
      couponCode: "Code promo",
      couponPlaceholder: "Saisissez votre code promo",
      couponValidating: "Validation du code en cours...",
      couponApplied: "Code promo appliqué",
      couponInvalid: "Code promo invalide",
      couponReasonExpired: "Ce code promo a expiré.",
      couponReasonOfferNotAllowed: "Ce code promo n'est pas valable pour cette offre.",
      couponReasonQuotaExhausted: "Ce code promo n'est plus disponible.",
      couponReasonCustomerEmailRequired: "Renseignez votre e-mail pour valider ce code promo.",
      couponReasonMinOrder: "Le montant minimum n'est pas atteint pour ce code promo.",
      couponReasonNotStarted: "Ce code promo n'est pas encore actif.",
      couponReasonBookingPeriod: "Ce code promo n'est pas valable pour la date de réservation sélectionnée.",
      discount: "Remise",
      continueToPayment: "Continuer vers le Paiement",
      processing: "Traitement en cours...",
      bookingSummary: "Récapitulatif de Réservation",
      name: "Nom",
      backToDetails: "Retour aux détails",
      expiryWarning: "Votre réservation expirera dans 15 minutes si le paiement n'est pas effectué.",
      paymentOverlayTitle: "Traitement de votre paiement",
      paymentOverlayMessage: "Veuillez patienter pendant le traitement sécurisé de votre paiement. Ne fermez pas cette page.",
      paymentOverlayConfirmTitle: "Confirmation de votre réservation",
      paymentOverlayConfirmMessage: "Paiement reçu ! Nous finalisons votre réservation avec WowBooking."
    },
    bookingConfirmation: {
      title: "Réservation confirmée",
      subtitle: "Merci d'avoir choisi Wownautic. Votre aventure est réservée !",
      processing: "Confirmation de votre paiement...",
      success: "Votre réservation est confirmée. Vous recevrez un email de confirmation sous peu.",
      errorTitle: "Problème de paiement",
      paymentFailed: "Le paiement n'a pas abouti. Veuillez réessayer.",
      paymentIncomplete: "Le paiement est encore en cours. Contactez-nous si vous avez été débité.",
      confirmError: "Paiement reçu mais la confirmation a échoué. Contactez le support.",
      missingBooking: "Lien de confirmation invalide. Contactez le support.",
      backHome: "Retour à l'accueil",
      contactUs: "Nous contacter",
      referenceLabel: "Référence de réservation",
      detailsTitle: "Votre réservation",
      experience: "Expérience",
      date: "Date",
      time: "Horaire",
      participants: "Participants",
      equipment: "Équipement",
      guest: "Nom",
      email: "Email",
      phone: "Téléphone",
      subtotal: "Sous-total",
      discount: "Réduction",
      totalPaid: "Total payé",
      meetingTitle: "Point de rendez-vous",
      meetingPoint: "Puerto Deportivo de Fuengirola, Costa del Sol",
      meetingHint: "Le numéro de quai et le lien Google Maps sont dans votre email de confirmation.",
      emailNotice: "Un email de confirmation avec tous les détails a été envoyé à {{email}}."
    },
    contactConfirmation: {
      title: "Message envoyé",
      subtitle: "Merci de nous avoir contactés. Nous avons bien reçu votre message et vous répondrons dans les meilleurs délais.",
      emailNotice: "Si votre demande est urgente, vous pouvez aussi nous joindre au +34 683 17 17 17.",
      backHome: "Retour à l'accueil",
      sendAnother: "Envoyer un autre message"
    },
    newsletterConfirmation: {
      titlePending: "Vérifiez votre boîte mail",
      subtitlePending: "Nous vous avons envoyé un email de confirmation. Cliquez sur le lien dans l'email pour finaliser votre inscription.",
      titleConfirmed: "Inscription confirmée",
      subtitleConfirmed: "Votre email a été confirmé ! Bienvenue à bord — vous recevrez nos dernières offres et actualités.",
      titleAlreadyVerified: "Déjà inscrit",
      subtitleAlreadyVerified: "Votre email figure déjà sur notre liste de newsletter.",
      titleInvalid: "Lien invalide",
      subtitleInvalid: "Ce lien de vérification est invalide ou a expiré.",
      titleError: "Une erreur est survenue",
      subtitleError: "Une erreur s'est produite lors de la confirmation de votre inscription. Veuillez réessayer.",
      backHome: "Retour à l'accueil",
      browseOffers: "Voir nos offres"
    },
    cookiePolicy: {
      title: "Politique de Cookies",
      whatAreCookies: {
        title: "Qu'est-ce qu'un Cookie ?",
        description: "Un cookie est un petit fichier texte qui est stocké dans votre navigateur lorsque vous visitez presque n'importe quel site web. Son utilité est que le site web soit capable de se souvenir de votre visite lorsque vous naviguez à nouveau sur cette page. Les cookies stockent généralement des informations techniques, des préférences personnelles, la personnalisation du contenu, des statistiques d'utilisation, des liens vers les réseaux sociaux, l'accès aux comptes d'utilisateurs, etc. L'objectif du cookie est d'adapter le contenu du site web à votre profil et à vos besoins. Sans cookies, les services offerts par n'importe quel site web seraient considérablement diminués.",
        moreInfo: "Si vous souhaitez plus d'informations sur ce que sont les cookies, ce qu'ils stockent, comment les supprimer, les désactiver, etc., veuillez consulter ce document."
      },
      cookiesUsed: {
        title: "Cookies Utilisés sur ce Site Web",
        intro: "Suivant les directives de l'Agence Espagnole de Protection des Données, nous détaillons l'utilisation des cookies faite par ce site web afin de vous informer aussi précisément que possible.",
        ownCookies: {
          title: "Ce site web utilise les cookies propres suivants :",
          session: "Cookies de session, pour garantir que les utilisateurs qui écrivent des commentaires sur le blog sont des humains et non des applications automatisées. De cette façon, le spam est combattu."
        },
        thirdPartyCookies: {
          title: "Ce site web utilise les cookies tiers suivants :",
          analytics: "Stocke des cookies pour compiler des statistiques sur le trafic et le volume de visites de ce site web. En utilisant ce site web, vous consentez au traitement d'informations vous concernant par Google. Par conséquent, l'exercice de tout droit à cet égard doit être fait en communiquant directement avec Google.",
          socialMedia: {
            title: "Réseaux Sociaux",
            description: "Chaque réseau social utilise ses propres cookies pour que vous puissiez cliquer sur des boutons tels que J'aime ou Partager."
          }
        }
      },
      disableDelete: {
        title: "Désactivation ou Suppression des Cookies",
        description: "À tout moment, vous pouvez exercer votre droit de désactiver ou de supprimer les cookies de ce site web. Ces actions sont effectuées différemment selon le navigateur que vous utilisez. Guide pour désactiver les cookies dans les navigateurs les plus populaires."
      },
      additionalNotes: {
        title: "Notes Additionnelles",
        note1: "Ni ce site web ni ses représentants légaux ne sont responsables du contenu ou de l'exactitude des politiques de confidentialité que les tiers mentionnés dans cette politique de cookies peuvent avoir.",
        note2: "Les navigateurs web sont les outils responsables du stockage des cookies et c'est à partir de cet endroit que vous devez exercer votre droit de les supprimer ou de les désactiver. Ni ce site web ni ses représentants légaux ne peuvent garantir la manipulation correcte ou incorrecte des cookies par les navigateurs mentionnés.",
        note3: "Dans certains cas, il est nécessaire d'installer des cookies pour que le navigateur n'oublie pas votre décision de ne pas les accepter.",
        note4: "Dans le cas des cookies Google Analytics, cette entreprise stocke les cookies sur des serveurs situés aux États-Unis et s'engage à ne pas les partager avec des tiers, sauf dans les cas où cela est nécessaire pour le fonctionnement du système ou lorsque la loi l'exige. Selon Google, ils ne stockent pas votre adresse IP. Google Inc. est une entreprise adhérant à l'Accord de Safe Harbor qui garantit que toutes les données transférées seront traitées avec un niveau de protection conforme à la réglementation européenne. Si vous souhaitez des informations sur l'utilisation que Google fait des cookies, nous joignons cet autre lien."
      },
      contact: "Pour toute question ou demande concernant cette politique de cookies, n'hésitez pas à nous contacter via la section contact."
    },
    privacyPolicy: {
      title: "Politique de Confidentialité",
      intro: {
        p1: "Ce document de Politique de Confidentialité établit les conditions dans lesquelles nous utilisons et protégeons les informations que vous nous fournissez lorsque vous utilisez le formulaire de contact de notre site Web ou nous envoyez un email.",
        p2: "Nous nous engageons à protéger vos données. Lorsque nous vous demandons de remplir le formulaire de contact avec des informations personnelles permettant de vous identifier, nous le faisons en veillant à ce qu'elles ne soient utilisées que conformément aux termes de ce document. Cependant, cette Politique de Confidentialité peut changer avec le temps ou être mise à jour, nous vous recommandons donc de consulter régulièrement cette page pour vous assurer que vous êtes d'accord avec ces changements."
      },
      responsible: {
        title: "Responsable",
        content: "WOW Nautic, adresse: Puerto Deportivo de Fuengirola 45, 29640 Málaga, email: info@wownautic.com et Tél.: +34 683 17 17 17."
      },
      dataCollected: {
        title: "Informations Collectées",
        content: "Notre site Web peut collecter des informations personnelles, par exemple: Nom, informations de contact telles que votre adresse email et/ou téléphone. De même, lorsque cela est nécessaire, des informations spécifiques peuvent être demandées, par exemple pour établir des factures."
      },
      dataUse: {
        title: "Utilisation des Informations Collectées",
        content: "Notre site Web utilise les informations afin de fournir le meilleur service possible, en particulier pour répondre aux messages que vous nous envoyez via le formulaire ou l'email, et améliorer nos produits ou services. Nous pouvons occasionnellement vous envoyer des emails via notre site avec des offres spéciales, de nouveaux produits et d'autres informations publicitaires que nous considérons pertinentes pour vous ou qui peuvent vous apporter un avantage. Ces emails seront envoyés à l'adresse que vous fournissez et peuvent être annulés à tout moment. Nous nous engageons fortement à maintenir vos informations en sécurité. Nous utilisons les systèmes les plus avancés et les mettons constamment à jour pour nous assurer qu'il n'y a pas d'accès non autorisé."
      },
      retention: {
        title: "Durée de Conservation de vos Données",
        p1: "Les données personnelles que vous nous fournissez seront conservées jusqu'à ce que vous demandiez leur suppression.",
        p2: "Dans le cas où nous ne maintenons pas d'interactivité avec vous, nous les conserverons pour une période maximale de cinq ans, sans préjudice de la possibilité d'exercer vos droits dans les termes indiqués ci-dessous.",
        p3: "Dans tous les cas, la période de conservation des données sera déterminée par la période obligatoire fixée par la réglementation commerciale, comptable et fiscale ou toute autre réglementation en vigueur qui établit obligatoirement une période de conservation supérieure aux précédentes."
      },
      legal: {
        title: "Base Légale pour le Traitement de vos Données Personnelles",
        content: "La base légale ou la légitimité du traitement des données personnelles fournies via le site Web est le consentement exprès qui vous est demandé pour chacune des finalités de traitement, la satisfaction de vos attentes, ainsi que l'exécution de mesures précontractuelles ou d'un contrat demandé par vous et l'intérêt légitime."
      },
      thirdParty: {
        title: "Liens vers des Tiers",
        content: "Ce site Web peut contenir des liens vers d'autres sites qui pourraient vous intéresser. Une fois que vous cliquez sur ces liens et quittez notre page, nous n'avons plus de contrôle sur le site vers lequel vous serez redirigé, et nous ne sommes donc pas responsables des conditions ou de la confidentialité ni de la protection des données sur ces autres sites tiers. Ces sites auront leurs propres politiques de confidentialité, il est donc recommandé de les consulter pour confirmer que vous êtes d'accord avec elles."
      },
      control: {
        title: "Contrôle de vos Informations Personnelles",
        content: "À tout moment, vous pouvez nous écrire à l'email du site Web pour restreindre ou annuler la collecte ou l'utilisation des informations personnelles que vous nous avez fournies. Nous ne vendrons, ne céderons ni ne distribuerons jamais les informations personnelles que nous collectons sans votre consentement, sauf si cela est requis par un juge avec une ordonnance judiciaire. Nous nous réservons le droit de modifier les termes de cette Politique de Confidentialité à tout moment, nous vous conseillons donc de la consulter lorsque vous naviguez sur notre site Web."
      },
      sharing: {
        title: "Cession de Données",
        content: "Les données ne seront pas cédées à des tiers, sauf autorisation expresse ou obligation ou permission légale."
      },
      rights: {
        title: "Droits Concernant le Traitement des Données Personnelles",
        p1: "Vous pouvez exercer, concernant les données collectées de la manière prévue dans cette Politique de Confidentialité, les droits reconnus dans la réglementation sur la protection des données et, en particulier, les droits suivants: accès, rectification, suppression, opposition, limitation et portabilité des données personnelles.",
        p2: "Vous avez le droit d'accéder à vos données personnelles, ainsi que de demander la rectification des données inexactes ou, le cas échéant, de demander leur suppression lorsque, entre autres raisons, les données ne sont plus nécessaires aux fins pour lesquelles elles ont été collectées.",
        p3: "Vous aurez toujours la possibilité de révoquer à tout moment le consentement pour l'un des traitements pour lesquels vous avez donné votre consentement, sans affecter la licéité du traitement basé sur le consentement avant son retrait.",
        p4: "Vous pouvez exercer les droits mentionnés dans le paragraphe, en indiquant dûment le motif de votre demande, par demande écrite et signée adressée à WOW Nautic – Puerto Deportivo de Fuengirola 45, 29640 Málaga ou en envoyant un email à l'adresse info@wownautic.com",
        p5: "Les demandes envoyées par email doivent être faites depuis l'adresse email enregistrée par le demandeur. Dans tous les cas, pour que vous puissiez exercer les droits susmentionnés et afin d'offrir des garanties sur votre identification en tant que demandeur, vous devez joindre à votre demande une copie de votre Carte d'Identité Nationale ou, le cas échéant, Numéro d'Identification d'Étranger, en vigueur.",
        p6: "De même, si vous considérez que vos données ont été traitées de manière inappropriée, vous aurez le droit de déposer une plainte auprès de l'Agence Espagnole de Protection des Données (C/ Jorge Juan, 6. 28001 – Madrid www.agpd.es)."
      },
      termsOfUse: {
        title: "Conditions d'Utilisation",
        p1: "L'utilisation de la page accorde le statut d'utilisateur et implique l'acceptation de la politique de confidentialité. Si vous n'êtes pas d'accord, vous vous abstiendrez d'utiliser la page.",
        p2: "Vous êtes obligé et vous vous engagez à utiliser la page et son contenu, conformément à la législation en vigueur et à tout avis contenu sur cette page. L'Utilisateur est obligé et s'engage à ne pas transmettre, diffuser ou mettre à la disposition de tiers tout contenu du site Web, tel que des informations, textes, données, contenus, messages, graphiques, dessins, fichiers son et/ou image, photographies, vidéos, logiciels, logos, marques, icônes, technologie, photographies, logiciels, liens, conception graphique et codes sources, ou tout autre matériel auquel vous avez accès en tant qu'Utilisateur de la Page, sans que cette énumération soit limitative."
      }
    }
  }
};
